import { render, staticRenderFns } from "./ModalMensajeCargando.vue?vue&type=template&id=f5471506&scoped=true"
import script from "./ModalMensajeCargando.vue?vue&type=script&lang=js"
export * from "./ModalMensajeCargando.vue?vue&type=script&lang=js"
import style0 from "./ModalMensajeCargando.vue?vue&type=style&index=0&id=f5471506&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5471506",
  null
  
)

export default component.exports